import { useState, useEffect, useRef } from 'react';
import { useToast, requestStatuses } from '@gulfwinds/ui-components';
import { downloadFile } from 'shared/../helpers/downloadFile';
import exportDataHandlingStrategies from './exportDataHandlingStrategies';

const defaultOptions = {
  dataHandlingStrategy: exportDataHandlingStrategies.GENERATE_SPREADSHEET_LOCALLY,
};

const useDataExport = (
  name,
  requestExport,
  searchParams,
  options = {},
) => {



  const { dataHandlingStrategy } = { ...defaultOptions, ...options };

  const [status, setStatus] = useState(requestStatuses.INIT);
  const [exported, setExported] = useState([]);
  const exporterRef = useRef(null);
  const toast = useToast();

  const strategiesHandlers = {
    [exportDataHandlingStrategies.GENERATE_SPREADSHEET_LOCALLY]: (options) => setExported(options.data),
    [exportDataHandlingStrategies.GENERATE_SPREADSHEET_SERVER_SIDE]: (options) =>
      downloadFile({
        data: options.data,
        name,
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      }),
  };

  const exportData = () => {
    setStatus(requestStatuses.PENDING);
    return requestExport(searchParams)
      .then((data) => {
        if (!data) {
          setStatus(requestStatuses.FAILED);
          return;
        }

        const options = { data };
        const handler = strategiesHandlers[dataHandlingStrategy];
        handler(options);
        setStatus(requestStatuses.SUCCESS);
      })
      .catch((error) => {
        console.error(`Error loading ${name} for Export`, error);
        toast.error({ message: `Failed to export ${name}`, error });
        setStatus(requestStatuses.FAILED);
      });
  };

  useEffect(() => {
    if (
      status === requestStatuses.SUCCESS &&
      exporterRef.current !== null &&
      dataHandlingStrategy === exportDataHandlingStrategies.GENERATE_SPREADSHEET_LOCALLY
    ) {
      exporterRef.current.save(exported);
    }
  }, [status]);

  return {
    status,
    setStatus,
    exported,
    exporterRef,
    exportData,
  };
};

export default useDataExport;
